import axios from "axios";
import logger from "./logService";
import { toastTimeout, toastError, toastBigError, toastInfo } from "../components/utils/toasts";

axios.defaults.withCredentials = true;

axios.defaults.headers.common["Authorization"] = localStorage.getItem("token");

// El server sólo devuelve 401 (sesión inválida) y 403 (token inválido/vencido)
// desde check-session/check-jwt, así que cualquiera de los dos significa que la
// sesión ya no sirve: limpiamos el token y volvemos a la pantalla principal.
// El flag evita que varias respuestas fallidas en paralelo disparen N redirects.
let cerrandoSesion = false;

const cerrarSesion = () => {
  localStorage.removeItem("token");
  delete axios.defaults.headers.common["Authorization"];
  if (cerrandoSesion) return;
  cerrandoSesion = true;
  window.location = "/";
};

axios.interceptors.response.use(null, (error) => {
  const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;
  if (!expectedError) {
    // toastBigError(error.message);
    logger.log(error);
  } else {
    switch (error.response.status) {
      case 400:
        toastError(error.response.data.message);
        // console.log("Info: " + error.response.data.message);
        break;
      case 401:
        console.log("Sesión Inválida", "Su sesión expiró, o se abrió en otro dispositivo");
        cerrarSesion();
        break;
      case 403:
        console.log("Token Inválido", "Su token expiró o no es válido");
        cerrarSesion();
        break;
      case 404:
        // toastError("No se encontró ese registro en el servidor");
        console.log("Error: No se encontró ese registro en el servidor");
        break;
    }
  }
  return Promise.reject(error);
});

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete,
};
